export default __webpack_public_path__ + "static/media/undraw_add_file.f93a2a2c.svg";